import http from './http';
import { wOrgIdMiddleware } from '../utils/commonUtils';

const HistoricalVisitService = {
  getBatches: wOrgIdMiddleware(async (orgUrl, query = {}) => {
    const params = {
      page: query.page,
      per_page: query.perPage || query.per_page,
    };
    const queryString = new URLSearchParams(
      Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
      )
    ).toString();
    const response = await http.GET(
      `${orgUrl}historical-visits/batches${queryString ? `?${queryString}` : ""}`
    );
    return response?.data;
  }),

  upload: wOrgIdMiddleware(async (orgUrl, formData) => {
    const response = await http.POST(`${orgUrl}historical-visits/upload`, formData, {
      'Content-Type': 'multipart/form-data',
    });
    if (!response) {
      return null;
    }
    return response.data ?? response;
  }),

  getBatchStatus: wOrgIdMiddleware(async (orgUrl, batchId) => {
    const response = await http.GET(`${orgUrl}historical-visits/batches/${batchId}/status`);
    return response?.data;
  }),

  getBatchMapping: wOrgIdMiddleware(async (orgUrl, batchId) => {
    const response = await http.GET(`${orgUrl}historical-visits/batches/${batchId}/mapping`);
    return response?.data;
  }),

  searchPatients: wOrgIdMiddleware(async (orgUrl, query = {}) => {
    const params = {
      q: query.q,
      dob: query.dob,
      limit: query.limit,
    };
    const queryString = new URLSearchParams(
      Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
      )
    ).toString();
    const response = await http.GET(
      `${orgUrl}historical-visits/patient-search${queryString ? `?${queryString}` : ""}`
    );
    return response?.data;
  }),

  mapPatient: wOrgIdMiddleware(async (orgUrl, batchId, fileIndex, employeeId) => {
    const response = await http.POST(
      `${orgUrl}historical-visits/batches/${batchId}/files/${fileIndex}/map-patient`,
      { employee_id: employeeId }
    );
    return response?.data;
  }),

  getHistoricalVisitRecord: wOrgIdMiddleware(async (orgUrl, employeeId, recordId) => {
    const response = await http.GET(
      `${orgUrl}employees/${employeeId}/historical-visits/${recordId}`
    );
    return response?.data;
  }),

  getEmployeeHistoricalVisits: wOrgIdMiddleware(async (orgUrl, employeeId, query = {}) => {
    const params = {
      page: query.page,
      per_page: query.perPage || query.per_page,
    };
    const queryString = new URLSearchParams(
      Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
      )
    ).toString();
    const response = await http.GET(
      `${orgUrl}employees/${employeeId}/historical-visits${queryString ? `?${queryString}` : ""}`
    );
    return response?.data;
  }),

  getHandoff: wOrgIdMiddleware(async (orgUrl, batchId, fileIndex) => {
    const response = await http.GET(
      `${orgUrl}historical-visits/handoffs/${batchId}/${fileIndex}`
    );
    return response?.data;
  }),

  deleteBatch: wOrgIdMiddleware(async (orgUrl, batchId) => {
    const response = await http.DELETE(`${orgUrl}historical-visits/batches/${batchId}`);
    return response?.data;
  }),
};

export default HistoricalVisitService;
